import { BlockTimeSetting } from '../types/Study';
import { DEFAULT_TIMED_SECONDS_PER_QUESTION } from '../config/examConfig';
export const DEFAULT_QBANK_BLOCK_SIZE = 20;

export const formatAccommodation = (
  accommodation: BlockTimeSetting | undefined,
  shorthand: boolean = false
) => {
  if (!accommodation || accommodation === BlockTimeSetting.default) return '';
  if (shorthand) {
    return formatShorthand(accommodation);
  }
  return accommodation.charAt(0).toUpperCase() + accommodation.slice(1);
};

const formatShorthand = (accommodation: BlockTimeSetting) => {
  switch (accommodation) {
    case BlockTimeSetting.default:
      return '';
    case BlockTimeSetting.quarter:
      return 'x1.25';
    case BlockTimeSetting.half:
      return 'x1.5';
    case BlockTimeSetting.double:
      return 'x2';
  }
};

export const resolveTimeAccommodationFactor = (
  timeSetting?: BlockTimeSetting
) => {
  switch (timeSetting) {
    case BlockTimeSetting.quarter:
      return 1.25;
    case BlockTimeSetting.half:
      return 1.5;
    case BlockTimeSetting.double:
      return 2;
    case BlockTimeSetting.default:
    default:
      return 1;
  }
};

// Mirrors ora-be blockTimeAccommodationHelpers: seconds per question of the
// exam (`getTimedSecondsPerQuestion`: 90 medical, 120 NCLEX) × count ×
// accommodation, rounded once.
export const calculateTimedBlockDurationSeconds = (
  questionCount: number,
  timeSetting?: BlockTimeSetting,
  secondsPerQuestion: number = DEFAULT_TIMED_SECONDS_PER_QUESTION
) => {
  const sanitizedQuestionCount = Math.max(0, questionCount);
  const multiplier = resolveTimeAccommodationFactor(timeSetting);
  return Math.round(sanitizedQuestionCount * secondsPerQuestion * multiplier);
};

export const coerceBlockTimeSetting = (
  value?: string | null
): BlockTimeSetting | undefined => {
  if (!value) {
    return undefined;
  }
  return (Object.values(BlockTimeSetting) as string[]).includes(value)
    ? (value as BlockTimeSetting)
    : undefined;
};
